module.exports = __webpack_public_path__ + "static/img/MV.4d6c425.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV.jpg
// module id = 0Tfi
// module chunks = 0